module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-topmenu'), _vm._v(" "), _c('section', [_c('router-view'), _vm._v(" "), _c('v-foot')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45a2a7fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 197
// module chunks = 1